<div class="dialog-container" [class.dialog-container-inline-tutorial]="shouldShowInlineTutorial"
    data-tutorial-target="role-help-dialog" data-tutorial-spotlight-self>
    <h2 class="role-header-text">{{ 'Role Explanations' | translate }}</h2>
    <mat-dialog-content class="mat-typography role-help-dialog-content" data-tutorial-target="role-help-dialog-content">

        <!-- LAB ROLES SECTION -->
        <h2 class="category-header">{{ '1. Lab Roles (Global Authority)' | translate }}</h2>
        <p class="intro-text">{{ 'Global roles apply to the entire Lab and all Gadgets within it.' | translate }}</p>

        <div class="role-section">
            <h3>{{ 'Lab Owner / Admin' | translate }}</h3>
            <p class="inheritance-note"><strong>{{ 'Inherited Status:' | translate }}</strong> {{ 'Lab Owners and Admins
                are automatically "Super Admins" for every Gadget. This status is inherited and granted automatically.'
                | translate }}</p>
            <ul>
                <li>{{ 'Full control over the Lab and all its Gadgets.' | translate }}</li>
                <li>{{ 'Manage Lab and Gadget settings.' | translate }}</li>
                <li>{{ 'Invite members and manage all roles.' | translate }}</li>
            </ul>
        </div>

        <div class="role-section">
            <h3>{{ 'Lab Creator' | translate }}</h3>
            <ul>
                <li>{{ 'Create new Gadgets within the Lab.' | translate }}</li>
                <li>{{ 'Manage the Gadgets you have created.' | translate }}</li>
                <li class="restriction"><i>{{ 'Cannot edit or manage Gadgets created by others.' | translate }}</i></li>
            </ul>
        </div>

        <div class="role-section">
            <h3>{{ 'Lab Viewer' | translate }}</h3>
            <ul>
                <li>{{ 'View the Lab and all its standard components.' | translate }}</li>
                <li>{{ 'Interact with components and use Lab Controllers.' | translate }}</li>
                <li class="restriction"><i>{{ 'Does NOT inherit access to private Gadgets unless explicitly added.' |
                        translate }}</i></li>
            </ul>
        </div>

        <hr class="section-divider">

        <!-- GADGET ROLES SECTION -->
        <h2 class="category-header">{{ '2. Gadget Roles (Local Elevation)' | translate }}</h2>
        <p class="intro-text">{{ 'Used to promote a **Lab User** within a specific Gadget.' | translate }}</p>

        <div class="role-section">
            <h3>{{ 'Gadget Creator (Selectable)' | translate }}</h3>
            <p class="role-adder">{{ 'Includes all Viewer permissions, plus:' | translate }}</p>
            <ul>
                <li><b>{{ 'Add Components' | translate }}</b>{{ ': Create new components in this Gadget.' | translate }}
                </li>
                <li><b>{{ 'Manage Own' | translate }}</b>{{ ': Edit or delete components you have created.' | translate
                    }}</li>
                <li class="restriction"><i>{{ 'Cannot edit or delete components created by others.' | translate }}</i>
                </li>
            </ul>
        </div>

        <div class="role-section">
            <h3>{{ 'Gadget Viewer (Selectable)' | translate }}</h3>
            <ul>
                <li>{{ 'Standard view and interaction for this specific Gadget.' | translate }}</li>
            </ul>
        </div>

    </mat-dialog-content>

    <div *ngIf="shouldShowInlineTutorial" class="role-help-tutorial-panel-inline">
        <app-tutorial-panel (actionClicked)="close()" (closeClicked)="close()">
        </app-tutorial-panel>
    </div>

    <mat-dialog-actions *ngIf="!shouldShowInlineTutorial" align="end">
        <button mat-button (click)="close()">{{ 'Close' | translate }}</button>
    </mat-dialog-actions>
</div>